import { FC } from 'react';
import { Button } from '@edikk-edikk/country-layout-black';
import { FormattedMessage } from 'react-intl';
import { useMenuButtonVariant } from '#baseMenu/components';
import { useBaseContext } from '#base/hooks';

const LinkToManage: FC = () => {
  const buttonVariant = useMenuButtonVariant();
  const { linkToManage } = useBaseContext();

  return (
    <Button
      linkSimpleProps={{ href: linkToManage }}
      variant={buttonVariant}
      pill
      textUppercase
      additionalClassName="flex-grow-1"
    >
      <FormattedMessage defaultMessage="Advertise" />
    </Button>
  );
};

export { LinkToManage };
